import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import bg from "./bg.jpg";
import "./Home.css"
import {faEnvelope, faExclamationTriangle, faPhone} from "@fortawesome/free-solid-svg-icons";
import {faInstagram, faLinkedin, faTelegram, faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import {useTranslation} from "react-i18next";

export function Home() {
  const {t} = useTranslation();

  return (
    <div style={{backgroundImage: `url(${bg})`}} className="background">
      <div className="d-flex align-items-center">
        <div className="container my-auto">
          <div className="row mt-5">
            <div className="card card-welcome col-xs-10 col-sm-10 col-md-10 col-lg-6 offset-xs-1 offset-sm-1 offset-md-1 offset-lg-3 shadow-lg">
              <div className="card-body text-center">
                <div className="h2 mb-3">{t("home.welcome")}</div>
                <div className="h4 mb-3">{t("home.welcome_2")}</div>
                <div className="col-sm-10 col-md-8 col-sm-1 offset-md-2">
                  <div className="card card-disclaimer border border-1 border-dark shadow-sm">
                    <div className="card-body text-center">
                      <div className="card-title fw-bold">
                        <FontAwesomeIcon icon={faExclamationTriangle} size="2x"/>
                        <div>{t("home.disclaimer_warning")}</div>
                      </div>
                      <div>{t("home.disclaimer_desc")}</div>
                      <div className="smaller mt-3">
                        <div>{t("home.disclaimer_desc_1")}</div>
                        <div className="mt-1">{t("home.disclaimer_desc_2")}</div>
                        <div className="mt-1">{t("home.disclaimer_desc_3")}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3">{t("home.disclaimer_name")}</div>
                <div>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/ketlenpereiranascimento/">
                    <FontAwesomeIcon icon={faLinkedin} size="2x" className="color-linkedin icon-link"/>
                  </a>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="mailto:eu@ketlen.com.br">
                    <FontAwesomeIcon icon={faEnvelope} size="2x" className="color-email icon-link"/>
                  </a>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="https://t.me/TiaKet">
                    <FontAwesomeIcon icon={faTelegram} size="2x" className="color-telegram icon-link"/>
                  </a>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/aquela.garota_ali/">
                    <FontAwesomeIcon icon={faInstagram} size="2x" className="color-instagram icon-link"/>
                  </a>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="https://wa.me/5521976971227">
                    <FontAwesomeIcon icon={faWhatsapp} size="2x" className="color-whatsapp icon-link"/>
                  </a>
                  <a className="m-2" target="_blank" rel="noopener noreferrer" href="tel:+5521976971227">
                    <FontAwesomeIcon icon={faPhone} size="2x" className="color-phone icon-link"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
